<template>
  <div class="termos-view internal">
    <section class="list">
      <div class="container">
        <h1 class="title-default">TERMO DE CONSENTIMENTO PARA TRATAMENTO DE DADOS PESSOAIS</h1>

        <article>
          <p>Este documento visa registrar a manifestação livre, informada e inequívoca pela qual o usuário concorda com o tratamento de seus dados pessoais para finalidade específica, em conformidade com a Lei nº 13.709 – Lei Geral de Proteção de Dados Pessoais (LGPD).</p>

          <p>Ao aceitar o presente termo, o usuário consente e concorda que a empresa FIBRA EXPERTS EMPREENDIMENTOS IMOBILIÁRIOS LTDA., inscrita no CNPJ/ME sob o nº 09.369.378/0001-31, com sede na Rua Alves Guimarães, 1120, 2º andar, CEP 05410-002, telefone (11) 2832-4400, doravante denominada Controladora, tome decisões referentes ao tratamento de seus dados pessoais, bem como realize o tratamento destes dados, envolvendo operações como as que se referem a coleta, produção, recepção, classificação, utilização, acesso, reprodução, transmissão, distribuição, processamento, arquivamento, armazenamento, eliminação, avaliação ou controle da informação, modificação, comunicação, transferência, difusão ou extração.</p>

          <h2>Dados pessoais</h2>
          <p>A Controladora fica autorizado a tomar decisões referentes ao tratamento e a realizar o tratamento dos seguintes dados pessoais do Titular:</p>

          <table>
            <tbody>
              <tr>
                <td>Nome completo</td>
                <td>Data de nascimento</td>
              </tr>

              <tr>
                <td>Número da cédula de identidade (RG)</td>
                <td>Número do Cadastro de Pessoas Físicas (CPF)</td>
              </tr>

              <tr>
                <td>Estado civil</td>
                <td>Profissão</td>
              </tr>

              <tr>
                <td>Endereço completo</td>
                <td>Telefone</td>
              </tr>

              <tr>
                <td>E-mail</td>
              </tr>
            </tbody>
          </table>

          <h2>Finalidades do tratamento dos dados</h2>

          <p>O tratamento dos dados pessoais listados neste termo tem as seguintes finalidades:</p>

          <ul>
            <li><strong>I</strong> - possibilitar que a Controladora identifique e entre em contato com o Titular para fins de relacionamento comercial;</li>
            <li><strong>II</strong> - possibilitar que a Controladora elabore contratos comerciais com o Titular e emita cobranças respectivas;</li>
            <li><strong>III</strong> -  possibilitar que a Controladora envie ou forneça ao Titular seus produtos e serviços, de forma remunerada ou gratuita;</li>
            <li><strong>IV</strong> - possibilitar que a Controladora estruture, teste, promova e faça propaganda de produtos e serviços, personalizados ou não ao perfil do Titular;</li>
            <li><strong>V</strong> - possibilitar que a Controladora utilize os dados para a venda/aluguel de imóvel, em qualquer tipo de plataforma de vendas, seja em meios físicos ou digitais podendo, para isso, validar e atualizar as informações cadastrais do Titular; validar o score de crédito do Titular; simular financiamentos em diversos bancos; corretagem imobiliária; contratar o financiamento para o imóvel; intermediar a compra, venda ou locação do imóvel, mediante a assinatura de contratos e realização do registro do imóvel no cartório.</li>
          </ul>

          <h2>Compartilhamento de dados</h2>
          <p>A Controladora fica autorizado a compartilhar os dados pessoais do Titular com outros agentes de tratamento de dados, caso seja necessário para as finalidades listadas neste termo, observados os princípios e as garantias estabelecidas pela Lei nº 13.709.</p>

          <h2>Segurança dos dados</h2>
          <p>A Controladora responsabiliza-se pela manutenção de medidas de segurança, técnicas e administrativas aptas a proteger os dados pessoais de acessos não autorizados e de situações acidentais ou ilícitas de destruição, perda, alteração, comunicação ou qualquer forma de tratamento inadequado ou ilícito. Em conformidade ao art. 48 da Lei nº 13.709, a Controladora comunicará ao Titular e à Autoridade Nacional de Proteção de Dados (ANPD) a ocorrência de incidente de segurança que possa acarretar risco ou dano relevante ao Titular.</p>

          <h2>Término do tratamento dos dados</h2>
          <p>A Controladora poderá manter e tratar os dados pessoais do Titular durante todo o período em que os mesmos forem pertinentes ao alcance das finalidades listadas neste termo.</p>

          <h2>Direitos do Titular</h2>
          <p>O Titular tem direito a obter da Controladora, em relação aos dados por ela tratados, a qualquer momento e mediante requisição:</p>
          <ul>
            <li><strong>I</strong> - confirmação da existência de tratamento;</li>
            <li><strong>II</strong> - acesso aos dados;</li>
            <li><strong>III</strong> - correção de dados incompletos, inexatos ou desatualizados;</li>
            <li><strong>IV</strong> - anonimização, bloqueio ou eliminação de dados desnecessários, excessivos ou tratados em desconformidade com o disposto na Lei nº 13.709;</li>
            <li><strong>V</strong> - portabilidade dos dados a outro fornecedor de serviço ou produto, mediante requisição expressa, de acordo com a regulamentação da autoridade nacional, observados os segredos comercial e industrial;</li>
            <li><strong>VI</strong> - eliminação dos dados pessoais tratados com o consentimento do titular, exceto nas hipóteses previstas no art. 16 da Lei nº 13.709;</li>
            <li><strong>VII</strong> - informação das entidades públicas e privadas com as quais o controlador realizou uso compartilhado de dados;</li>
            <li><strong>VIII</strong> - informação sobre a possibilidade de não fornecer consentimento e sobre as consequências da negativa;</li>
            <li><strong>IX</strong> - revogação do consentimento, nos termos do § 5º do art. 8º da Lei nº 13.709.</li>
          </ul>

          <h2>Direito de revogação do consentimento</h2>
          <p>Este consentimento poderá ser revogado pelo usuário, a qualquer momento, mediante solicitação via e-mail ou correspondência à Controladora.</p>

          <p>
            Qualquer dúvida ou esclarecimento, contate nosso canal direto <a target="_blank" href="mailto:dpo@fibraexperts.com.br" title="dpo@fibraexperts.com.br">dpo@fibraexperts.com.br</a>
            <br />
            Acesse nossa política de privacidade <a target="_blank" href="https://www.fibraexperts.com.br/politica-privacidade" title="Política de privacidade">https://www.fibraexperts.com.br/politica-privacidade</a>
          </p>
        </article>
      </div> <!-- /.container -->
    </section> <!-- /.list -->
  </div>
</template>

<script>
export default {
}
</script>

<style lang="sass" scoped>
  @import '@/assets/sass/_base.sass'

  .internal
    padding-top: 25px
    max-height: calc(100vh - 40px)
    overflow: auto
    background: #f3f3f3

    article
      font-size: 14px
      line-height: 20px

      p
        font-size: 14px
        margin-bottom: 15px
        display: block

      a
        text-decoration: underline
        color: map-get($colors, primary)

      h2
        font-size: 18px
        line-height: 24px
        font-weight: 600
        margin-bottom: 5px
        padding-top: 15px
        display: block

      table
        margin: 0 auto  30px
        border: 1px solid #ccc

        td
          border: 1px solid #ccc
          padding: 5px 15px

      ul
        background: transparent
        border-radius: 0
        border: none
        margin-bottom: 10px

        li
          padding: 0 0 0 15px
          font-size: 14px
          margin-bottom: 5px
          border-bottom: none
          display: block

          @media (max-width: 1024px)
            background: transparent
            border: none

          strong
            font-weight: 800

</style>
